/*
 * studio nuveria — bande photo défilante.
 *
 * Transforme la grille d'emplacements média d'une section en un ruban qui défile
 * en continu, façon mur d'inspirations. Le ruban est dupliqué une fois pour que
 * la boucle soit sans couture, et la copie est masquée aux lecteurs d'écran.
 *
 * Amélioration progressive : sans JavaScript, la grille d'origine reste affichée
 * telle quelle, rien ne casse.
 *
 * Sections concernées : celles dont l'identifiant se termine par un des suffixes
 * de SECTION_IDS, ou celles qui portent la classe `photo-band-section`. Cette
 * classe se saisit dans « Classe CSS additionnelle » de la section, ce qui permet
 * d'activer le défilement sur une autre section sans repasser par le code.
 */

const SECTION_IDS = ['__section_ambiances'];
const SECTION_CLASS = 'photo-band-section';

const SELECTOR = SECTION_IDS.map((id) => `[id$="${id}"]`)
  .concat(`.${SECTION_CLASS}`)
  .join(',');

function build(container) {
  const inner = container.querySelector('.custom-section__inner');
  if (!inner || inner.dataset.photoBand === 'done') return;

  const slots = [...inner.children].filter((child) => child.classList.contains('media-slot'));
  if (slots.length < 2) return;

  const band = document.createElement('div');
  band.className = 'photo-band';
  band.style.setProperty('--photo-band-count', slots.length);

  const track = document.createElement('div');
  track.className = 'photo-band__track';
  slots.forEach((slot) => track.appendChild(slot));
  band.appendChild(track);

  const copy = track.cloneNode(true);
  copy.setAttribute('aria-hidden', 'true');
  copy.querySelectorAll('img, video').forEach((media) => media.setAttribute('loading', 'lazy'));
  band.appendChild(copy);

  inner.appendChild(band);
  inner.dataset.photoBand = 'done';
}

function init(root) {
  (root || document).querySelectorAll(SELECTOR).forEach(build);
}

init();

// L'éditeur de thème re-rend la section à chaque réglage modifié.
document.addEventListener('shopify:section:load', (event) => init(event.target));